import jQuery from "jquery";
import { Events } from '../events'

jQuery(document).ready(function($) {
    const $emitters = $('.event-emit');
    if($emitters.length > 0) {
        $emitters.each( function (){
            $(this).on('click', function (event){
                event.preventDefault();
                const el = event.currentTarget;
                if(el.hasAttribute('data-event')){
                    Events.emit(el.dataset.event);
                }
            })
        });
    }
});
